import { Component, ojs, app } from "modular-openscriptjs";
import { dom, tool } from "../../fotastart";
import { cleanDispose, inform, store } from "../../helpers";
import { STRINGS } from "../../declarations";

const h = app("h");
const broker = app("broker");
const $e = app("$e");

const TERMS_AND_CONDITIONS_URL = "https://carata.co/terms-and-conditions/";
const TERMS_AND_CONDITIONS_KEY = "paymentTc";

export default class TermsAndConditionsForm extends Component {
    holder = null;

    render(...args) {
        return h.empty();
    }

    $$termsAndConditions = {
        needs: {
            acceptance: (ed, event) => this.showForm(),
        },
    };

    showForm() {
        // Avoid stacking multiple copies of the modal if the event fires
        // more than once (e.g. several guarded routes in a row).
        if (this.holder) return;

        this.holder = tool.plainModal(
            h.TermsAndConditionsModal(
                this.renderBody(),
                this.renderFooter(),
            ),
            {
                data_bs_backdrop: "static",
                data_bs_keyboard: "false",
            },
        );

        this.holder.show();
    }

    renderBody() {
        return h.div(
            { class: "text-center" },
            h.div(
                {
                    class: "d-inline-flex align-items-center justify-content-center rounded-circle bg-primary-subtle mb-3",
                    style: "width: 64px; height: 64px;",
                },
                h.i({ class: "bi bi-shield-check text-primary fs-3" }),
            ),
            h.h4({ class: "fw-bold mb-2" }, "Accept Our Terms & Conditions"),
            h.p(
                { class: "text-muted mb-1" },
                "Please review and accept Carata's Terms and Conditions to continue using the app.",
            ),
            h.a(
                {
                    href: TERMS_AND_CONDITIONS_URL,
                    target: "_blank",
                    class: "text-decoration-none fw-semibold",
                },
                "Read our Terms and Conditions",
            ),
        );
    }

    renderFooter() {
        return h.div(
            { class: "w-100" },
            h.button(
                {
                    class: "btn btn-primary rounded-pill px-4 py-3 fw-bold shadow-sm w-100",
                    id: "accept-terms-and-conditions-btn",
                    onclick: this.method("accept"),
                },
                "Yes, I Accept",
            ),
        );
    }

    async accept() {
        let btn = dom.id("accept-terms-and-conditions-btn");
        if (btn) {
            dom.put(
                h.div({
                    class: "spinner-border spinner-border-sm text-white",
                    role: "status",
                }),
                btn,
            );
            dom.disable(btn);
        }

        await store(TERMS_AND_CONDITIONS_KEY, 1);

        broker.send($e.termsAndConditions.accepted);

        inform(
            "Thank you for accepting our Terms and Conditions. You can now use Carata",
            STRINGS.SUCCESS,
        );

        this.closeForm();

        // Re-run the route that was blocked so it can render now
        // that terms and conditions have been accepted.
        window.location.reload();
    }

    closeForm() {
        if (this.holder) {
            this.holder.hide();
            cleanDispose(this.holder);
            this.holder = null;
        }
    }

    cleanUp() {
        super.cleanUp();
        if (this.holder) cleanDispose(this.holder);
    }
}

export function TermsAndConditionsModal(bodyContent, footerContent) {
    return h.$(
        h.div(
            {
                class: "modal-content border-0 rounded-4 shadow-lg",
            },
            h.div(
                {
                    class: "modal-body p-4",
                },
                bodyContent,
            ),
            h.div(
                {
                    class: "modal-footer p-4",
                },
                footerContent,
            ),
        ),
    );
}

ojs(TermsAndConditionsForm, TermsAndConditionsModal);
